import { render, staticRenderFns } from "./admin-setting-division.vue?vue&type=template&id=11e0bb05"
import script from "./admin-setting-division.vue?vue&type=script&lang=js"
export * from "./admin-setting-division.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports